import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { Invest } from '@classes/invest/invest';
import { ProviderType } from '@enums/provider-type.enum';
import { InvestService } from '@services/invest.service';
import { AuthService } from '@services/auth.service';

@Component({
    selector: 'app-invest-projects',
    templateUrl: './invest-projects.component.html',
    styleUrls: ['./invest-projects.component.scss']
})
export class InvestProjectsComponent implements OnInit, OnDestroy {
    private investSub: Subscription;

    invest: Invest;
    isLoading: boolean;
    provider: ProviderType
    providerType = ProviderType;

    constructor(
        private investSrv: InvestService,
        private authSrv: AuthService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
        this.provider = this.authSrv.getDecodedToken().provider_category;
    }

    eval(): void {
        this.isLoading = true;
        this.investSrv.calculate(this.invest)
        .subscribe(() => {
            this.isLoading = false;
        });
    }

    private initSubscriptions(): void {
        this.investSub = this.investSrv.investChanged
        .subscribe(invest => {
            this.invest = invest;
        });
    }

    ngOnDestroy(): void {
        if(this.investSub) {
            this.investSub.unsubscribe();
        }
    }
}
